window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.ui-tooltip').length) {
    import('./_tooltips.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
